import React, { useEffect } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import Breadcrumbs from 'components/Breadcrumbs';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import CastMember from '../Cast/CastMember';
import Style from './SeeAll.module.scss';

const SeeAll = ({
  breadcrumbsData,
  breakpoint,
  castInfo,
  contentCode,
  contentName,
  disableScroll,
  isCast = true,
  items,
  pageTitle,
  seriesType,
}) => {
  const returnButton = (
    <div className={Style.returnButtonContainer}>
      <Link className={Style.returnButton} to={`/${contentCode}/`}>
        <Icon color="white" size="medium" icon="ios-arrow-left" />
        {`Back to ${contentName}`}
      </Link>
    </div>
  );
  const allItems =
    items.length > 0 &&
    items.map(castMember => (
      <div className={Style.castItem} key={castMember.id}>
        <CastMember
          breakpoint={breakpoint}
          disableScroll={disableScroll}
          info={castMember}
          isCast={isCast}
          showCode={contentCode}
        />
      </div>
    ));

  useEffect(() => {
    handleAnalytics({
      event: Events.CAST_LANDING,
      payload: {
        pageName: `detail:${seriesType}:${pageTitle}:cast-landing`,
        pageType: `detail:${seriesType}:cast`,
      },
    });
  }, [pageTitle, seriesType]);

  return (
    <div className={Style.gridContainer}>
      {returnButton}
      {items.length > 0 ? (
        <>
          <h1 className={Style.header}>{`Meet the ${items[0].category}`}</h1>
          <div className={Style.allItemsContainer}>{allItems}</div>
        </>
      ) : (
        Object.keys(castInfo).map(key => (
          <>
            <h1 className={Style.header}>{`Meet the ${castInfo[key][0].category}`}</h1>
            <div className={Style.allItemsContainer}>
              {castInfo[key].map(castMember => (
                <div className={Style.castItem} key={castMember.id}>
                  <CastMember
                    breakpoint={breakpoint}
                    disableScroll={disableScroll}
                    info={castMember}
                    isCast={isCast}
                    showCode={contentCode}
                  />
                </div>
              ))}
            </div>
          </>
        ))
      )}
      <Breadcrumbs data={breadcrumbsData} customStyle={Style.breadcrumb} />
    </div>
  );
};

SeeAll.propTypes = {
  breadcrumbsData: PropTypes.arrayOf(PropTypes.shape({})),
  breakpoint: PropTypes.string,
  castInfo: PropTypes.shape({}),
  contentCode: PropTypes.string,
  contentName: PropTypes.string,
  disableScroll: PropTypes.func,
  isCast: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  pageTitle: PropTypes.string,
  seriesType: PropTypes.string,
};

export default SeeAll;
